import { DEFAULT_CONFIGURATION as DEFAULT_BAR_CHART_CONFIGURATION } from './sidebar/BarChartConfiguration';
import { DEFAULT_CONFIGURATION as DEFAULT_PIE_CHART_CONFIGURATION } from './sidebar/PieChartConfiguration';
import { DEFAULT_CONFIGURATION as DEFAULT_LINE_CHART_CONFIGURATION } from './sidebar/LineChartConfiguration';
import { DEFAULT_CONFIGURATION as DEFAULT_SCATTER_PLOT_CONFIGURATION } from './sidebar/ScatterPlotConfiguration';
import { DEFAULT_CONFIGURATION as DEFAULT_SCATTER_BUBBLE_PLOT_CONFIGURATION } from './sidebar/ScatterBubblePlotConfiguration';

export default function defaultChartConfiguration(chartType) {
  const defaultConfig = {
    BarChart: DEFAULT_BAR_CHART_CONFIGURATION,
    PieChart: DEFAULT_PIE_CHART_CONFIGURATION,
    LineChart: DEFAULT_LINE_CHART_CONFIGURATION,
    ScatterPlot: DEFAULT_SCATTER_PLOT_CONFIGURATION,
    ScatterBubblePlot: DEFAULT_SCATTER_BUBBLE_PLOT_CONFIGURATION,
  }[chartType];

  if (!defaultConfig) {
    console.warn(
      `Could not determine default configuration for chart type ${chartType}`
    );
  }

  return defaultConfig || {};
}
